import React from 'react';
import PropTypes from 'prop-types';

import { useDispatch } from 'react-redux';
import ThreadItem, { threadItemShape } from './ThreadItem';
import { asyncDownVoteThread, asyncNeutralVoteThread, asyncUpVoteThread } from '../../../middleware/thread/action';
import { ThreadLists } from '../../styled';

const ThreadList = ({ threads }) => {
  const dispatch = useDispatch();

  const onDownVoteThread = ({ id }) => {
    dispatch(asyncDownVoteThread(id));
  };

  const onNeutralVoteThread = ({ id }) => {
    dispatch(asyncNeutralVoteThread(id));
  };

  const onUpVoteThread = ({ id }) => {
    dispatch(asyncUpVoteThread(id));
  };

  return (
    <ThreadLists>
      {
        threads.map((thread) => (
          <ThreadItem
            key={thread.id}
            id={thread.id}
            {...thread}
            onDownVoteThread={onDownVoteThread}
            onNeutralVoteThread={onNeutralVoteThread}
            onUpVoteThread={onUpVoteThread}
          />
        ))
      }
    </ThreadLists>
  );
};

ThreadList.propTypes = {
  threads: PropTypes.arrayOf(PropTypes.shape(threadItemShape)).isRequired,
};

export default ThreadList;
